<template>
  <header>
    <div class="header-content clearfix">
      <div class="left logo clearfix relative">
        <img src="../assets/img/logo_drcnet.png" alt="logo" class="drcnet-logo" @click="openLink('http://www.drcnet.com.cn/www/int/')">
        <img src="../assets/img/logo_other.png" alt="logo" @click="openLink('http://www.tushengcn.com')">
        <div class="line"></div>
      </div>
      <!--<img class="pointer logo"-->
           <!--src="@/assets/img/logo.png" alt="logo" @click="$router.push('/')">-->
      <div class="right right-header">
        <div class="iblock header-search">
          <el-select v-model="select" placeholder="请选择" size="small">
            <el-option label="标题" value="1"></el-option>
            <el-option label="作者" value="2"></el-option>
          </el-select>
          <el-input placeholder="请输入搜索内容"
                    v-model="search"
                    class="input-with-select" size="small" suffix-icon="el-icon-search">
          </el-input>
        </div>
        <el-button class="ml10" type="primary" size="small" @click="toSearchByText">检索</el-button>
        <el-button class="ml10" type="info" size="small" @click="toSearchCenter">检索中心</el-button>
        <el-button @click="login" type="primary" size="small" v-if="!isLogin">登录</el-button>
        <span v-else class="ml10 clof iblock">已登录,<a
          @click="loginOut" class="clof login-out pointer">退出</a></span>
      </div>
    </div>
  </header>
</template>

<script>
import { login, loginOut } from '../utils';

export default {
  name: 'TopNav',
  data() {
    return {
      search: '',
      select: '1',
      isLogin: false,
    };
  },
  methods: {
    login() {
      login();
    },
    loginOut() {
      const { query, name } = this.$route;
      loginOut(query, name);
    },
    setLoginStatus() {
      const { userToken } = this.$store.state;
      if (userToken) this.isLogin = true;
    },
    toSearchCenter() {
      window.location.href = 'http://s1.drcnet.com.cn/search/SearchAC.aspx?chnId=6280';
    },
    toSearchByText() {
      const { select, search } = this;
      const encodeSearch = escape(search);
      window.location.href = `http://s1.drcnet.com.cn/search/SearchAC.aspx?chnId=6280&fields=${select}^1^1^${encodeSearch}`;
    },
    openLink(link) {
      window.open(link);
    },
  },
  created() {
    this.setLoginStatus();
  },
};
</script>

<style scoped lang="scss">
header{
  background: #0c5a92;
  /*background: rgba(55, 157, 244, 0.8);*/
}
.login-out{
  &:hover{
    text-decoration: underline;
  }
}
.header-content{
  /*width: 1200px;*/
  /*margin: 0 auto;*/
  height: 58px;
  line-height: 58px;
  .drcnet-logo{
    margin-right: 57px;
  }
  .line{
    width: 1px;
    height: 20px;
    position: absolute;
    left: 50%;
    top: calc(50% + 5px);
    background-color: white;
  }
  .logo{
    width: 267px;
    height: 30px;
    margin-left: 10%;
  }
  img{
    vertical-align: middle;
    width: 105px;
    height: 30px;
    cursor: pointer;
  }
  .right-header{
    margin-right: 20%;
  }
  /deep/
  .el-select .el-input {
    width: 75px;
    line-height: normal;
  }
  .input-with-select{
    width: 300px;
  }
}
</style>
